import colorNames from './HexToColor.json'; // Adjust the path as needed

const getColorName = (hex) => {
    // Get the color name from the imported JSON object
    return colorNames[hex.toLowerCase()] || "Unknown Color";
};

export default getColorName;